import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSubNavigationQueryVariables = Types.Exact<{
  language: Types.Scalars['String']['input'];
}>;


export type GetSubNavigationQuery = { __typename?: 'Query', bingo: Array<{ __typename?: 'Bingo', id: string, view_all_first_collection?: boolean | null, internal_name?: string | null, icon?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, translations?: Array<{ __typename?: 'Bingo_translations', slug: string, title: string } | null> | null, collections?: Array<{ __typename?: 'Bingo_Collections_1', id: string, Collections_id?: { __typename?: 'Collections', translations?: Array<{ __typename?: 'Collections_translations', slug?: string | null } | null> | null } | null } | null> | null }>, spins: Array<{ __typename?: 'spins', id: string, internal_name?: string | null, view_all_first_collection?: boolean | null, icon?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, translations?: Array<{ __typename?: 'spins_translations', slug: string, title: string } | null> | null, collections?: Array<{ __typename?: 'spins_Collections_1', id: string, Collections_id?: { __typename?: 'Collections', translations?: Array<{ __typename?: 'Collections_translations', slug?: string | null } | null> | null } | null } | null> | null }> };


export const GetSubNavigationDocument = gql`
    query getSubNavigation($language: String!) {
  bingo: Bingo(filter: {status: {_eq: "published"}}) {
    id
    view_all_first_collection
    internal_name
    icon {
      filename_disk
      width
      height
    }
    translations(
      filter: {languages_language_code: {language_code: {_eq: $language}}}
    ) {
      slug
      title
    }
    collections(filter: {Collections_id: {status: {_eq: "published"}}}, limit: 1) {
      id
      Collections_id {
        translations(
          filter: {languages_language_code: {language_code: {_eq: $language}}}
        ) {
          slug
        }
      }
    }
  }
  spins(filter: {status: {_eq: "published"}}) {
    id
    internal_name
    view_all_first_collection
    icon {
      filename_disk
      width
      height
    }
    translations(
      filter: {languages_language_code: {language_code: {_eq: $language}}}
    ) {
      slug
      title
    }
    collections(filter: {Collections_id: {status: {_eq: "published"}}}, limit: 1) {
      id
      Collections_id {
        translations(
          filter: {languages_language_code: {language_code: {_eq: $language}}}
        ) {
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useGetSubNavigationQuery__
 *
 * To run a query within a React component, call `useGetSubNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubNavigationQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useGetSubNavigationQuery(baseOptions: Apollo.QueryHookOptions<GetSubNavigationQuery, GetSubNavigationQueryVariables> & ({ variables: GetSubNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubNavigationQuery, GetSubNavigationQueryVariables>(GetSubNavigationDocument, options);
      }
export function useGetSubNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubNavigationQuery, GetSubNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubNavigationQuery, GetSubNavigationQueryVariables>(GetSubNavigationDocument, options);
        }
export function useGetSubNavigationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubNavigationQuery, GetSubNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubNavigationQuery, GetSubNavigationQueryVariables>(GetSubNavigationDocument, options);
        }
export type GetSubNavigationQueryHookResult = ReturnType<typeof useGetSubNavigationQuery>;
export type GetSubNavigationLazyQueryHookResult = ReturnType<typeof useGetSubNavigationLazyQuery>;
export type GetSubNavigationSuspenseQueryHookResult = ReturnType<typeof useGetSubNavigationSuspenseQuery>;
export type GetSubNavigationQueryResult = Apollo.QueryResult<GetSubNavigationQuery, GetSubNavigationQueryVariables>;